// native
import { Component, Input, OnInit } from '@angular/core';

// service
import { AuthService } from 'app/core/services/auth.service';
import { TechallSessionService } from 'app/core/services/techall-session.service';
import { NavigationService } from 'app/core/services/navigation.service';

// models
import { OfficeGroupItem, UserAuthResponse } from '../../../models';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent implements OnInit {

  officeGroups: OfficeGroupItem[];
  selectedOfficeGroupId: number;

  isLoading: boolean = false;

  @Input() navExpanded;
  @Input() transparentMode;

  constructor(
    public authService: AuthService,
    public techallService: TechallSessionService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.officeGroups = this.authService.getOfficeGroups();
    this.selectedOfficeGroupId = this.authService.storedOfficeGroupId;
  }

  submit() {
    this.isLoading = true;
    this.authService.switchOfficeGroup(this.selectedOfficeGroupId).subscribe(() => {
      this.isLoading = true;
      this.authService.bootstrapUser().subscribe((authResponse: UserAuthResponse) => {
        // Clear localStorage + the on-prem PII IndexedDB before storing the new
        // office group's data, mirroring the login path. Without this, PHI-bearing
        // work-item filters and stale privacy flags (only written when truthy)
        // from the previous office survive the switch.
        this.authService.clearLocalData();
        this.authService.storeUserData(authResponse);
        if (this.navigationService.isParameterizedRoute)
          window.location.href = window.location.origin;
        else
          window.location.reload();
      }, () => this.isLoading = false);
    }, () => this.isLoading = false);
  }
}
